import { useState } from 'react'
import toast from 'react-hot-toast'
import { ImageType } from '../../interfaces/intakes.reports'
import { SortableList } from '../sortable/SortableList'
import { useReorderImages } from '../../api/useEditImages'
import { ModalBtn } from '../modals/ModalBtn'

interface Props {
    images: ImageType[]
    closeModal: () => void
    palletId: string
    reportId: string
}
export const ModalImageReorder = ({ closeModal, reportId, palletId, images }: Props) => {

    const [sortabledImages, setSortabledImages] = useState<ImageType[]>(images)
    const { mutate, isLoading } = useReorderImages()

    const sendImages = async () => {
        mutate({
            reportId,
            palletId,
            newImages: sortabledImages
        }, {
            onSuccess: async () => {
                toast.success("Images reordered successfully");
                closeModal()
            }
        })
    }

    return (
        <div className="modal">

            <div className="modal__card tw-touch-none">

                <div className="modal__content">

                    <SortableList
                        initialImages={images}
                        updatedOrder={(newImages) => setSortabledImages(newImages as ImageType[])}
                        className='tw-mb-4'
                    />

                    <ModalBtn
                        closeModal={closeModal}
                        action={sendImages}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </div>

    )
}
